export default __webpack_public_path__ + "static/media/logoDark.6eb5d7e0.svg";